import { Injectable, inject } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable()
export class HubAdminTypeaheadService {
    private httpService: HttpService = inject(HttpService);
    
    
}
